import React from 'react';

const IconSquare = () => (
  <svg id="square" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84 84">
    <title>Square</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon points="0 0 78 0 78 90 0 90" fill="currentColor" />
      </g>
    </g>
  </svg>
);

export default IconSquare;
